import React from "react";
import { Modal } from "@/design-system/Atoms/Modal";
import { Typography } from "@/design-system/Atoms";

interface TestimonialViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  firstName: string;
}

const TestimonialViewModal: React.FC<TestimonialViewModalProps> = ({
  isOpen,
  onClose,
  message,
  firstName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Testimonial"
      size="xl"
      className="max-h-[90vh]"
    >
      <div className="p-6">
        <Typography
          as="p"
          variant="sectionDescriptionSmall"
          className="text-[1.125rem] text-[#3b4151] mb-4"
        >
          {message}
        </Typography>
        <Typography
          as="h6"
          variant="sectionDescriptionSmall"
          className="text-[1.125rem] text-[#181a20]"
        >
          {`- ${firstName}`}
        </Typography>
      </div>
    </Modal>
  );
};

export default TestimonialViewModal;
